// extracted by mini-css-extract-plugin
export default {"page-indicator":"_paginationFooter_page-indicator__4sd+2"};